import template from 'lodash/template';
import classnames from 'classnames';
import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';
import React, { useContext } from 'react';
import { withStyles } from '@glu/theming';
import LocaleContext from '../locale/LocaleContext';
import ModalNotification from '../modalNotification/ModalNotification';
import styles from './SessionExpiration.styles';

const ExpirationView = (props) => {
  const locale = useContext(LocaleContext);

  const {
    classes: {
      actionBtns,
      centerPopupWindow,
      countDown,
      countDownLabel,
      instructions,
      modal,
      resumeBtn,
      timeRemaining
    },
    emulation,
    isApplicationTabHidden,
    onLogout,
    onResume,
    popupMode,
    sending,
    show,
    time
  } = props;

  const resume = locale['sessionExpiration.resume'];
  const logout = locale['sessionExpiration.logout'];
  const instructionsTemplate = locale['sessionExpiration.buttonInstructionsTemplate'];

  const dangerousHTML = {
    __html: template(instructionsTemplate)({
      resume: `<b>${resume}</b>`,
      countEnd: '<b>0.</b>'
    })
  };

  return (
    <ModalNotification
      className={modal}
      dialogClassName={classnames({ [centerPopupWindow]: popupMode && isApplicationTabHidden })}
      variant="error"
      data-qa="session-expiration-alert"
      show={show}
      disableBackdropClick
      closeButton={false}
      suppressIcon={false}
      footer={
        <div className={actionBtns}>
          <Button
            className={classnames('btn btn-primary', resumeBtn)}
            data-qa="expiration-resume"
            disabled={sending}
            onClick={onResume}
            text={resume}
            variant={PRIMARY}
          />
          <Button
            className="btn btn-tertiary"
            data-qa="expiration-logout"
            disabled={sending}
            onClick={onLogout}
            text={logout}
            variant={TERTIARY}
          />
        </div>
      }
      hideBackdrop={isApplicationTabHidden}
      emulation={emulation}
    >
      <div className="modal-header">{locale['sessionExpiration.header']}</div>

      <div className={timeRemaining}>
        <span className={countDownLabel}>{locale['sessionExpiration.timeRemaining']}</span>
        <span className={countDown}>{time}</span>
      </div>

      <div
        className={instructions} // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={dangerousHTML}
      />
    </ModalNotification>
  );
};

export default withStyles(styles)(ExpirationView);
